"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _imageUrl = _interopRequireDefault(require("@sanity/image-url"));
var _getWindow2 = _interopRequireDefault(require("./utils/get-window"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DEFAULT_PIXEL_RATIO = 1;
var imageUrlBuilder = function imageUrlBuilder(config) {
  return function (source) {
    var _getWindow$devicePixe, _getWindow;
    var devicePixelRatio = (_getWindow$devicePixe = (_getWindow = (0, _getWindow2["default"])()) === null || _getWindow === void 0 ? void 0 : _getWindow.devicePixelRatio) !== null && _getWindow$devicePixe !== void 0 ? _getWindow$devicePixe : DEFAULT_PIXEL_RATIO;
    return (0, _imageUrl["default"])({
      dataset: config.dataset,
      projectId: config.projectId
    }).image(source).auto('format') // raster formats will use webp where available instead of png/jpg.
    .dpr(Math.min(5, devicePixelRatio)) // Set device pixel ratio when available (2x/3x res for retina screens).
    .fit('max') // Don't enlarge images when source image is smaller than width/height.
    .quality(80).width(5) // Set a tiny default, so we fail tiny and obvious instead of ruining performance.
    .height(5); // Set a tiny default, so we fail tiny and obvious instead of ruining performance.
  };
};
var _default = exports["default"] = imageUrlBuilder;
module.exports = exports.default;